const ENV = {
    development: {
      API_BASE_URL: 'http://localhost:5002', //http://localhost:5002
    },
    production: {
      API_BASE_URL: 'https://schoolapi.trial.com.ng', //https://schoolapi.trial.com.ng
    },
  };
  
  const getEnvVars = () => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
  
      if (hostname === 'localhost' || hostname.startsWith('127.0.0.1')) {
        return ENV.development;
      }
    }
  
    // fallback based on process.env.NODE_ENV
    if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
      return ENV.development;
    }
  
    return ENV.production;
  };
  
  export default getEnvVars();
  